// extracted by mini-css-extract-plugin
export default {"router":"EO3ByGdUm5QUyE9B9ojr"};